<!--
 * @Description: 教职工详情 兼职教师聘用
 * @Author: 张天伟
 * @Date: 2023-03-08 17:10:56
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:53:33
-->

<template>
  <div>
    <el-descriptions class="descript-box" v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="全职工作单位" label-align="right" align="left" width="120px" span="2">{{item.qzgzdw}}</el-descriptions-item>
      <el-descriptions-item label="聘用起始日期" label-align="right" align="left" width="120px" span="2">{{item.pyqsrq}}</el-descriptions-item>
      <el-descriptions-item label="聘用终止日期" label-align="right" align="left" width="120px" span="2">{{item.pyzzrq}}</el-descriptions-item>
      <el-descriptions-item label="兼职岗位" label-align="right" align="left" width="120px" span="2">{{item.jzgwbt}}</el-descriptions-item>
      <el-descriptions-item label="合同编号" label-align="right" align="left" width="120px" span="2">{{item.htbh}}</el-descriptions-item>
      <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = {
        url: '/api/v2/renliziyuan/jiaozhigongjianzhijiaoshipinyong/list',
        data: { id: props.row.id, order: 'gh', sort: 'asc' }
      }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
